import { api } from "@/redux/api";

import {
	ApolloPeopleRequestParams,
	ApolloSavePeopleRequestParams,
	UpdateApolloSavePeopleRequestParams,
} from "@/types/apollo";

import {
	Apollo,
	ApolloSchema,
	SavedApolloPeopleSchema,
} from "../../pages/Apollo/schema/get-apollos";

/**
 * A list's saved Apollo config (source, lead filter, exclusion, counter): created by the list
 * filter step and updated by list filters, list details, the tracker find-person step and
 * onboarding. The admin Apollo search pages and their endpoints were removed (PREC-5023).
 */
export const apolloApi = api.injectEndpoints({
	endpoints: (builder) => ({
		saveSearchApolloPeople: builder.mutation<
			ApolloPeopleRequestParams,
			ApolloSavePeopleRequestParams
		>({
			query: (body) => ({
				url: "apollo/search/people/save",
				method: "POST",
				body,
				responseSchema: SavedApolloPeopleSchema,
			}),
			invalidatesTags: (result, error, arg) => [{ type: "List", id: arg.listId }, "Apollos"],
		}),
		updateApollo: builder.mutation<Partial<Apollo>, UpdateApolloSavePeopleRequestParams>({
			query: ({ id, refreshListId, ...body }) => ({
				url: `apollo/${id}`,
				method: "PATCH",
				body,
				responseSchema: ApolloSchema,
			}),
			invalidatesTags: (result, error, arg) => [
				{ type: "List", id: arg.listId ?? arg.refreshListId },
				"Apollos",
			],
		}),
	}),
});

export const { useUpdateApolloMutation, useSaveSearchApolloPeopleMutation } = apolloApi;
export const accountApiReducer = apolloApi.reducer;
export const accountApiMiddleware = apolloApi.middleware;
